import { ROLE_META, ROLE_BADGE_COLOR, normalizeRole } from './roles';
import { cn } from '@/lib/utils';

/**
 * Rounded pill role badge (port of RoleBadge in DrawerPane.kt): bg @15% / border @40% of the role color.
 * Lives in `@/auth/` per CONTRACTS.md §7 (the deleted `src/components/RoleBadge.tsx`).
 * `role` is a raw role string (AppRole code, display name, or `ROLE_`-prefixed claim) — normalized here.
 */
export function RoleBadge({ role, className }: { role: string; className?: string }) {
  const norm = normalizeRole(role);
  const color = norm ? ROLE_BADGE_COLOR[norm] : '#0A84FF'; // primaryBlue fallback
  const label = norm ? ROLE_META[norm].label : role;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium',
        className,
      )}
      style={{ color, borderColor: `${color}66`, backgroundColor: `${color}26` }}
    >
      {label}
    </span>
  );
}
